import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { isEqual } from 'lodash';
import { connect } from 'react-redux';
import { setAccountLink } from '../../../../redux/actions';

import { session } from '../../../../services/session';
import { authService } from '../../../../services/auth';
import { paymentsService } from '../../account/payments-service';

import Icon from '../../../ui/icon';

import './account-dropdown.scss';

class AccountDropdown extends Component {
  constructor(props) {
    super(props);

    this.AuthService = authService;

    this.pubAccountItem = {
      new: {
        title: 'Account Settings',
        url: `/v2/publisher/${session.orgId}/account-settings/general-settings`,
      },
      old: {
        title: 'Account',
        url: '/#/publisher/account',
        group: 'settings',
      },
    };

    this.merchAccountItem = {
      new: {
        title: 'Account Settings',
        url: `/v2/merchant/${session.orgId}/account-settings/general-settings`,
      },
      old: {
        title: 'Account',
        url: '/#/merchant/account',
        group: 'settings',
      },
    };

    this.fullname = '';
    this.dropdownNode = null;

    this.state = {
      publisherMenu: [this.pubAccountItem.new],
      merchantMenu: [this.merchAccountItem.new],
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick.bind(this), false);

    if (this.canGetAccountLink()) {
      this.getAccountLink();
    } else {
      this.props.setAccountLink({});
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.flags, prevProps.flags)) {
      this.setState({
        publisherMenu: [this.pubAccountItem.new],
        merchantMenu: [this.merchAccountItem.new],
      });

      if (this.canGetAccountLink()) {
        this.getAccountLink();
      } else {
        this.props.setAccountLink({});
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClick.bind(this), false);
  }

  handleClick(event) {
    if (this.dropdownNode && !this.dropdownNode.contains(event.target)) {
      this.dropdownNode.classList.remove('open');
    }
  }

  getMenu() {
    if (!this.props.currentUser) return [];

    switch (this.props.userRole) {
      case 'merchant':
        return this.state.merchantMenu;
      case 'publisher':
        return this.state.publisherMenu;
      default:
        return [];
    }
  }

  toggleDropdown() {
    this.dropdownNode.classList.toggle('open');
  }

  logout() {
    this.AuthService.logout(true);
  }

  navigateTo(url) {
    if (![this.pubAccountItem.new.url, this.merchAccountItem.new.url].includes(url)) {
      window.location = url;
    } else {
      this.props.history.push(url);
      this.dropdownNode.classList.remove('open');
    }
  }

  canGetAccountLink() {
    return this.props.flags.billingFeatures && paymentsService.checkIfBillingUser();
  }

  async getAccountLink() {
    const res = await paymentsService.getAccountLink(this.props.currentUser.orgId);
    this.props.setAccountLink(res.data.data[0]);
  }

  render() {
    this.fullname = `${this.props.currentUser.firstName} ${this.props.currentUser.lastName}`;

    const alertIcon =
      paymentsService.showAlertIcon(this.props.accountLink) &&
      this.props.flags.billingFeatures &&
      !this.props.flags.paymentsNavitem ? (
        <div className="alert-icon-container">
          <Icon iconName="filledAlert" size={16} />
        </div>
      ) : null;

    return (
      <div ref={node => (this.dropdownNode = node)} className="account-dropdown">
        <div className="dropdown-toggle" tabIndex={0} onClick={this.toggleDropdown.bind(this)}>
          <span>{this.fullname}</span>
          <span className="narrativ-icon down"></span>
        </div>
        <ul className="dropdown-menu">
          {this.getMenu().map((item, i) => {
            return (
              <li
                key={i}
                className={item.title.toLowerCase()}
                onClick={() => this.navigateTo(item.url)}
              >
                {item.title}
                {alertIcon}
              </li>
            );
          })}
          <li className="logout" onClick={this.logout.bind(this)}>
            Sign out
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    accountLink: state.accountLink,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setAccountLink: accountLink => dispatch(setAccountLink(accountLink)),
  };
};

export default withLDConsumer()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AccountDropdown)),
);
